export default __webpack_public_path__ + "static/media/gogo.20fcf6c8.png";